var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrnament3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.81 44.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.64,11.78l2.81,5.89a3.15,3.15,0,0,0,2.37,1.79l6.29.95A3.29,3.29,0,0,1,33.86,26l-4.55,4.6a3.36,3.36,0,0,0-.91,2.89l1.08,6.48a3.18,3.18,0,0,1-4.58,3.44l-5.62-3.06a3,3,0,0,0-2.93,0l-5.62,3.06a3.18,3.18,0,0,1-4.58-3.44l1.08-6.48a3.36,3.36,0,0,0-.91-2.89L1.77,26a3.29,3.29,0,0,1,1.75-5.56l6.28-.95a3.15,3.15,0,0,0,2.38-1.79L15,11.78A3.1,3.1,0,0,1,20.64,11.78Z",
    fill: "#c48c10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18,8.18c.25,0,.49,0,.73.05a8.17,8.17,0,0,1,1,.16,1.28,1.28,0,0,1,1,1.11,9.31,9.31,0,0,1,.08,1.5c0,.26,0,.53,0,.79s0,.33-.31.25a1.75,1.75,0,0,0-1.41.2.32.32,0,0,1-.31,0,2.14,2.14,0,0,0-1.77,0l-.09,0a.37.37,0,0,1-.38,0,2.81,2.81,0,0,0-.47-.21,1.47,1.47,0,0,0-.75,0l-.28.06a.22.22,0,0,1-.29-.2,3.18,3.18,0,0,1-.06-.43c-.05-.54-.1-1.08-.14-1.63a4,4,0,0,1,0-.49.66.66,0,0,1,.25-.5,2,2,0,0,1,.61-.35,8.22,8.22,0,0,1,1.62-.35l.27,0V8.05c0-1.29,0-2.59-.08-3.88,0-.82,0-1.63,0-2.45,0-1.28.6-2.49.7,1.62,0,.84,0,1.68.05,2.52s0,1.48.05,2.22A.16.16,0,0,0,18,8.18Z",
    fill: "#cccbcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrnament3);
export default __webpack_public_path__ + "static/media/ornament3.8f2cd566f1ef082ed22d4825a2813b1a.svg";
export { ForwardRef as ReactComponent };